import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type Params = Parameters<typeof apiClient.updatePricingPlan>[0];

export const usePricingPlanUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ plan_id, data }: { plan_id: number; data: Params }) =>
      await apiClient.updatePricingPlan(data, { params: { id: plan_id } }),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({
        queryKey: ["pricing_plans"],
      });
      void queryClient.invalidateQueries({
        queryKey: [
          {
            entity: "pricing_plans",
            params: {
              id: data,
            },
          },
        ],
      });
    },
  });
};
